import { CommonConfig } from '../types';

export const config: CommonConfig = {
  appType: process.env.REACT_APP_APP_TYPE as 'benefit' | 'merchants',
  idpUrl: process.env.REACT_APP_IDP_URL ?? '',
  imagesUrl: process.env.REACT_APP_IMAGES_URL ?? '',
  videosUrl: process.env.REACT_APP_VIDEOS_URL ?? '',
  defaultLanguage: process.env.REACT_APP_DEFAULT_LANG ?? '',
  languages: process.env.REACT_APP_LANGS?.split(',') ?? ['ro', 'en'],
  thumbnailHeight: process.env.REACT_APP_THUMBNAIL_HEIGHT ?? '',
  thumbnailWidth: process.env.REACT_APP_THUMBNAIL_WIDTH ?? '',
  idpAuthority: process.env.REACT_APP_IDP_AUTHORITY ?? '',
  idpClientId: process.env.REACT_APP_IDP_CLIENT_ID ?? '',
  idpInactivityWarningSeconds: Number.parseInt(
    process.env.REACT_APP_IDP_INACTIVITY_WARNING_SECONDS ?? '900',
  ),
  idpRedirectUri: process.env.REACT_APP_IDP_REDIRECT_URI ?? '',
  environment: process.env.REACT_APP_ENVIRONMENT ?? '',
  idpPostLogoutRedirectUri:
    process.env.REACT_APP_IDP_POST_LOGOUT_REDIRECT_URI ?? '',
  currency: process.env.REACT_APP_CURRENCY ?? '',
  env: process.env.NODE_ENV,
  dateFormat: process.env.REACT_APP_DATE_FORMAT ?? 'DD.MM.YYYY',
  timeFormat: process.env.REACT_APP_TIME_FORMAT ?? 'HH:mm ',
  dateTimeFormat:
    process.env.REACT_APP_DATE_TIME_FORMAT ?? 'DD.MM.YYYY / HH:mm',
  grid: {
    pageSizes: JSON.parse(process.env.REACT_APP_GRID_PAGE_SIZES ?? ''),
    defaultPageSize: Number.parseInt(
      process.env.REACT_APP_GRID_DEFAULT_PAGE_SIZE ?? '0',
    ),
  },
  listPageSize: Number.parseInt(
    JSON.parse(process.env.REACT_APP_LIST_PAGE_SIZE ?? '0'),
  ),
  debounceDelay: Number.parseInt(process.env.REACT_APP_DEBOUNCE_DELAY ?? '500'),
  toastVisibilityTimeMs: Number.parseInt(
    process.env.REACT_APP_TOAST_VISIBILITY_TIME_MS ?? '7000',
  ),
  gdprUrl: process.env.REACT_APP_GDPR_URL ?? '',
  filtersToDisplay: Number.parseInt(
    process.env.REACT_APP_DISPLAYED_FILTERS ?? '8',
  ),
  appLogCStr: process.env.REACT_APP_APP_INSIGHTS_CSTR ?? '',
};
